import { ExaminerAvailabilityDisplay, formatExaminerAvailabilityTime } from "./ExaminerAvailabilityDisplay";
import { Icon } from "semantic-ui-react";
import styled from "@emotion/styled";
import { RoomStructureAssignedExaminerWithAvailability } from "./useRoomStructureExaminerAllocation";

type Props = {
  assignedExaminerWithAvailability: RoomStructureAssignedExaminerWithAvailability;
  structureStartTime?: string;
  structureEndTime?: string;
};

export const RoomStructureExaminerAllocationPopup = ({ assignedExaminerWithAvailability, structureStartTime, structureEndTime }: Props) => {
  const { firstName, lastName, phoneNumber, email, examinerNumber, availabilities, unavailabilities, availability } = assignedExaminerWithAvailability;

  return (
    <>
      <S.PopupLine>
        <Icon name="user" /> {firstName} {lastName}
      </S.PopupLine>
      <S.PopupLine>
        <Icon name={availability!.icon} color={availability!.color} /> {availability!.popupHeader}
      </S.PopupLine>
      <S.PopupLine>
        <Icon name="time" /> {formatExaminerAvailabilityTime(structureStartTime!)} - {formatExaminerAvailabilityTime(structureEndTime!)}
      </S.PopupLine>
      <S.PopupLine>
        <Icon name="id card" /> {examinerNumber}
      </S.PopupLine>
      <S.PopupLine>
        <Icon name="phone square" /> {phoneNumber}
      </S.PopupLine>
      <S.PopupLine>
        <Icon name="mail" /> {email}
      </S.PopupLine>
      <ExaminerAvailabilityDisplay availabilities={availabilities} unavailabilities={unavailabilities} />
    </>
  );
};

const S = {
  PopupLine: styled.div`
    display: flex;
    align-items: center;
    gap: 0.5em;
    font-size: 0.85em;
    min-width: 250px;
  `
};